import {SearchModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {MetaTagDefinitionReferenceData, MetaTagType} from "../../catalogue/meta-tag/meta-tag.data";

@Injectable()
export class DocketSelectorSearchModel extends SearchModel<MetaTagDefinitionReferenceData> {

    constructor(injector: Injector) {
        super(injector);
        this.filter["type"] = MetaTagType.DOCKET_SELECTOR;
    }

    override getIdentifierField(): string {
        return "metaTagDefinitionId";
    }

    override getResourceName(): string {
        return "meta-tag-definition";
    }

    override getResource(): string {
        return "docket-selector";
    }
}
